import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenDataByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenDataByIdController.php
* @route '/api/screen-settings/{screen}/data'
*/
const GetScreenDataByIdController = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenDataByIdController.url(args, options),
    method: 'get',
})

GetScreenDataByIdController.definition = {
    methods: ["get","head"],
    url: '/api/screen-settings/{screen}/data',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenDataByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenDataByIdController.php
* @route '/api/screen-settings/{screen}/data'
*/
GetScreenDataByIdController.url = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screen: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screen: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screen: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screen: typeof args.screen === 'object'
        ? args.screen.id
        : args.screen,
    }

    return GetScreenDataByIdController.definition.url
            .replace('{screen}', parsedArgs.screen.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenDataByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenDataByIdController.php
* @route '/api/screen-settings/{screen}/data'
*/
GetScreenDataByIdController.get = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenDataByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenDataByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenDataByIdController.php
* @route '/api/screen-settings/{screen}/data'
*/
GetScreenDataByIdController.head = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenDataByIdController.url(args, options),
    method: 'head',
})

export default GetScreenDataByIdController